import styled from 'styled-components';
import { PromoCodeStyled } from '../PromoCodeStyled';
import { rem } from 'polished';

export const PromoCodeStyledAP = styled(PromoCodeStyled)``;
